// extracted by mini-css-extract-plugin
module.exports = {"articles":"article_articles__O9PDy","article":"article_article__3nDIv"};